import { Placement } from "@floating-ui/react";
import * as React from "react";
import MultiUseTooltip from "..";
interface ITryUnlimitedAndTryMuseTooltip {
  children: React.ReactNode;
  showTryUnlimitedTooltip: boolean;
  showTryMuseTooltip: boolean;
  onTryUnlimitedClosed: () => void;
  onTryMuseClosed: () => void;
  defaultTooltipDisabled: boolean;
  defaultTooltipContent: React.ReactNode;
  tryUnlimitedImage: string;
  tryMuseImage: string;
  tryUnlimitedArrowOffset?: number;
  tryMuseArrowOffset?: number;
  // My Voice onboarding tooltip (optional)
  showMyVoiceTooltip?: boolean;
  onMyVoiceClosed?: () => void;
  myVoiceContent?: React.ReactNode;
  myVoiceArrowOffset?: number;
}

export const TryUnlimitedAndTryMuseTooltip: React.FC<ITryUnlimitedAndTryMuseTooltip> = ({
  children,
  onTryMuseClosed,
  onTryUnlimitedClosed,
  defaultTooltipDisabled,
  defaultTooltipContent,
  showTryMuseTooltip,
  showTryUnlimitedTooltip,
  tryUnlimitedImage = "/assets/pick-unlimited-draft.gif",
  tryMuseImage = "/assets/pick-muse-draft.gif",
  tryUnlimitedArrowOffset = 0,
  tryMuseArrowOffset = 0,
  showMyVoiceTooltip = false,
  onMyVoiceClosed,
  myVoiceContent,
  myVoiceArrowOffset = 0,
}: ITryUnlimitedAndTryMuseTooltip) => {
  const writeButtonTooltipContent = [
    // My Voice onboarding always-on tooltip (highest priority)
    {
      content: myVoiceContent,
      onClose: () => onMyVoiceClosed?.(),
      closable: true,
      tooltipClasses: "w-[360px] max-w-[90vw] p-0 text-left rounded-[20px] !bg-[var(--tooltip-background)]",
      isOpen: showMyVoiceTooltip,
      animate: true,
      showArrow: true,
      controlledOpen: true,
      disabled: false,
      isShown: !!showMyVoiceTooltip,
      placement: "bottom" as Placement,
      arrowOffset: myVoiceArrowOffset,
      closeButtonClassName: "!top-4 !right-4 !w-6 !h-6 [&_svg]:!w-6 [&_svg]:!h-6 [&_svg]:!fill-[var(--context-menu-text)]",
      arrowColor: "var(--tooltip-background)",
    },
    {
      content: (
        <div className="">
          <p className="mb-2 text-left">
            Try another <strong>Prose Mode</strong> for different writing styles, including Unlimited (free for a limited time)!
          </p>
          <img
            src={tryUnlimitedImage}
            className="w-full h-full"
            alt="Pick Unlimited Mode"
          />
        </div>
      ),
      onClose: () => onTryUnlimitedClosed(),
      closable: true,
      tooltipClasses: "w-[300px] max-w-[90vw] p-4 text-left",
      isOpen: showTryUnlimitedTooltip,
      animate: true,
      showArrow: true,
      controlledOpen: true,
      disabled: false,
      isShown: showTryUnlimitedTooltip,
      placement: "bottom" as Placement,
      arrowOffset: tryUnlimitedArrowOffset,
    },
    {
      content: (
        <div className="">
          <p className="mb-2 text-left">
            Try another <strong>Prose Mode</strong> for different writing styles, including Muse, the first AI model made just for fiction!
          </p>
          <img
            src={tryMuseImage}
            className="w-full h-full"
            alt="Pick Muse Mode"
          />
        </div>
      ),
      onClose: () => onTryMuseClosed(),
      closable: true,
      tooltipClasses: "w-[300px] max-w-[90vw] p-4 text-left",
      isOpen: showTryMuseTooltip,
      animate: true,
      showArrow: true,
      controlledOpen: true,
      disabled: false,
      isShown: showTryMuseTooltip,
      placement: "bottom" as Placement,
      arrowOffset: tryMuseArrowOffset,
    },
    {
      content: defaultTooltipContent,
      onClose: undefined,
      closable: false,
      tooltipClasses: "",
      isOpen: undefined,
      animate: false,
      controlledOpen: false,
      showArrow: true,
      disabled: defaultTooltipDisabled || showMyVoiceTooltip,
      isShown: !showMyVoiceTooltip && !showTryUnlimitedTooltip && !showTryMuseTooltip && defaultTooltipContent !== null && !defaultTooltipDisabled,
      placement: "bottom" as Placement,
      arrowOffset: 0,
    },
  ];
  return <MultiUseTooltip tooltips={writeButtonTooltipContent}>{children}</MultiUseTooltip>;
};

export default TryUnlimitedAndTryMuseTooltip;
